import { AuthorizationResult, Spinner } from '@cp-shared-15/frontend-ui';
import { useMarketingPreferences } from 'components/my-profile/marketing-preferences-sections';
import {
    contactDetailsHookPagePath,
    dashboardPagePath,
    introductionPagePath,
    marketingPreferencesHookPagePath,
} from 'components/navigation/paths';
import { lastContactDetailsHookPageKey } from 'config';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useAuthorizationFlow } from '../../auth';
import { isIntroductionHookPage, isUserDetailsHookPage } from './utils';
import { useMyProfile } from '../my-profile';

export const HookPageRedirection: React.FC = () => {
    const history = useHistory();
    const { state } = useAuthorizationFlow();

    const {
        data: marketingPreferences,
        hasReceivedResponse: hasReceivedPreferencesResponse,
    } = useMarketingPreferences();

    const lastContactDetailsHookPage = window.localStorage.getItem(lastContactDetailsHookPageKey);

    const showUserDetailsHookPage = isUserDetailsHookPage(
        (state as AuthorizationResult<{ isAuthorized: boolean; lastAccess: string }>).lastAccess,
        lastContactDetailsHookPage || '',
    );
    const { data: personalDetails, hasReceivedResponse: hasReceivedPersonalDetailsResponse } = useMyProfile();

    const isEmailInMarketingPreferencesSet = marketingPreferences?.vwfs.email;

    const isContactEmailDefined = !!personalDetails?.contactDetails.email;

    useEffect(() => {
        if (!hasReceivedPreferencesResponse || !hasReceivedPersonalDetailsResponse) {
            return;
        }

        if (isIntroductionHookPage()) {
            history.push(introductionPagePath());
            return;
        }

        if (showUserDetailsHookPage) {
            if (isEmailInMarketingPreferencesSet) {
                history.push(contactDetailsHookPagePath());
                return;
            }

            history.push(marketingPreferencesHookPagePath());
            return;
        }

        if (!isContactEmailDefined) {
            history.push(contactDetailsHookPagePath());
            return;
        }

        history.push(dashboardPagePath());
    }, [
        history,
        hasReceivedPersonalDetailsResponse,
        hasReceivedPreferencesResponse,
        isEmailInMarketingPreferencesSet,
        isContactEmailDefined,
        showUserDetailsHookPage,
    ]);

    return <Spinner fullPage />;
};
